/**
 * JSON WEB Token Environment configuration.
 */
export interface IJwtEnvConfig {
  accessTokenConfig: IJwtOptions;
  refreshTokenConfig: IJwtOptions;
}

export class JwtEnvConfig implements IJwtEnvConfig {
  accessTokenConfig: IJwtOptions;
  refreshTokenConfig: IJwtOptions;
}

export interface IJwtOptions {
  expiresIn: number;
  issuer: string;
  privateKey: string;
  publicKey: string;
}

export class JwtOptions implements IJwtOptions {
  public expiresIn: number;
  public issuer: string;
  public privateKey: string;
  public publicKey: string;

  constructor(
    expiresIn: number,
    issuer: string,
    privateKey: string,
    publicKey: string
  ) {
    this.expiresIn = expiresIn;
    this.issuer = issuer;
    this.privateKey = privateKey;
    this.publicKey = publicKey;
  }
}
